// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__3CKxi","activeHandle":"RangeSlider_activeHandle__1wsLS"};